import React, { useEffect, useState, useCallback } from "react";
//import { tableOptionsUser } from "../../../Themes/LightTheme";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  Button,
  Box,
  IconButton,
  //Checkbox,
  FormControlLabel,
} from "@mui/material";
import {
  Grid,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
} from "@material-ui/core";

const UploadDrawingDialog = React.memo(
  ({ open, onClose, onUpload }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState("");

    useEffect(()=>{

      setError('')
    },[])

    
    const handleFileChange = (event) => {
      const file = event.target.files[0]
      if(file){
        if(file.type != "application/pdf"){
          setError("Only Pdf Files are allowed to upload.");
          setSelectedFile(null);
        }else{
          setError("");
          setSelectedFile(file);
        }
      }
     
     
      
    };

    const handleUpload = () => {

     if(!selectedFile){
      setError("Please select a file to upload.");
      return;
     }

     if(selectedFile.type != "application/pdf"){
      setError("Only Pdf Files are allowed to upload.");
      return
     }
     onUpload(selectedFile);
     setSelectedFile(null);
     setError("");
    };

    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" 
       sx={{
        "& .MuiDialog-paper": {
          width: "50%",
          minWidth: 500,
          maxWidth: "90vw",
          height: "auto",
          maxHeight: "110vh",
          padding: 3,
        },
      }}>
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center", position:"relative" }}>
          Upload Drawing
          <IconButton
            onClick={onClose}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ margin: "16px" }}>
            <Grid item xs={12} md={6} sm={6}>
              <TextField
                id="uploadDrwaingFile"
                variant="filled"
                className="bulk-upload"
                type="file"
                name="bulkUpload"
                onChange={handleFileChange}
                 InputProps={{
                  inputProps:{
                    accept:"application/pdf",
                    sx:{
                      position:"relative",
                      fontSize:"14px",
                      transition:"background-color 200ms cubic-bezier(0.0,0,0.2,1) 0ms",
                      backgroundColor: '#EBF7F8',
                      borderTopLeftRadius:"0px",
                      borderTopRightRadius:"0px",
                      border: '0', 
                      borderBottom: '1px solid #00CCCC'
                    }
                  }
                 }}
              />


            </Grid>
            <Grid item xs={12} md={6} sm={6}>
            <Button
            className="btn"
            variant="contained"
            color="primary"
            type="submit"
            //fullWidth
            disabled={selectedFile ? false : true}
            onClick={handleUpload}
          >
            Upload 
          </Button>
            </Grid>
          </Grid>
           {error && (
                        <Typography color="error" sx={{ mt: 2, textAlign: "left" }}>
                          {error}
                        </Typography>
                      )}
        </DialogContent>
       
      </Dialog>
    );
  }
);
export default UploadDrawingDialog;
